"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _sizing = require("./sizing");
var _breakpoints = _interopRequireDefault(require("./breakpoints"));
var _typography = _interopRequireDefault(require("./typography"));
var _polished = require("polished");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var _default = {
  gridSize: 12,
  width: '1280px',
  gutterWidth: (0, _polished.rem)(_sizing.space.lg, _typography.default._root).split('rem')[0],
  outerMargin: (0, _polished.rem)(_sizing.space.lg, _typography.default._root).split('rem')[0],
  mediaQuery: 'only screen',
  breakpoints: {
    xs: 0,
    sm: (0, _polished.em)(_breakpoints.default.sm, _typography.default._root).split('em')[0],
    md: (0, _polished.em)(_breakpoints.default.md, _typography.default._root).split('em')[0],
    lg: (0, _polished.em)(_breakpoints.default.lg, _typography.default._root).split('em')[0]
  }
};
exports.default = _default;